export default "__VITE_ASSET__Z6jWSpsV__"